import React from 'react';

function Pagination10({
  totalItems,
  rowsPerPage,
  startIndex,
  onRowsPerPageChange,
  onFirstItems,
  onPreviousItems,
  onNextItems,
  onLastItems,
}) {
  const endIndex = startIndex + rowsPerPage;
  const buttonBaseStyle = {
    minWidth: '36px',
    height: '28px',
    padding: '0 0.45rem',
    borderRadius: '6px',
    border: '1px solid #4b5563',
    backgroundColor: '#f3f4f6',
    color: '#6f7379',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    boxShadow: '0 1px 2px rgba(75, 85, 99, 0.2)',
  };
  const disabledButtonStyle = {
    ...buttonBaseStyle,
    color: '#b8c0cc',
    border: '1px solid #d5dbe3',
    backgroundColor: '#f8fafc',
    boxShadow: 'none',
  };
  const iconStyle = {
    fontSize: '0.9rem',
    fontWeight: 700,
    lineHeight: 1,
  };
  const pageInfoStyle = {
    minWidth: '98px',
    height: '28px',
    padding: '0 0.75rem',
    borderRadius: '6px',
    border: '1px solid #cfd8dc',
    backgroundColor: '#ffffff',
    color: '#1f2937',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
  };

  return (
    <div
      className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center gap-2 py-0 my-0 bg-white"
      style={{ fontSize: '0.85rem' }}
    >
      <div className="d-flex align-items-center flex-wrap gap-2">
        <div className="d-flex align-items-center gap-2">
          <label
            htmlFor="rowsPerPageSelect"
            className="form-label mb-0"
            style={{ whiteSpace: 'nowrap' }}
          >
            Exibir:
          </label>
          <select
            id="rowsPerPageSelect"
            className="form-select form-select-sm"
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
            style={{ width: '90px', minWidth: '90px', height: '28px', borderRadius: '6px', paddingTop: '0.1rem', paddingBottom: '0.1rem' }}
          >
            <option value={10}>10</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={totalItems}>Todos</option>
          </select>
        </div>
        <span className="text-muted">registros | {totalItems} no total</span>
      </div>

      <div className="d-flex align-items-center flex-wrap justify-content-end gap-2">
        <div className="d-flex align-items-center gap-2">
          <button
            className="btn btn-sm btn-light"
            onClick={onFirstItems}
            disabled={startIndex === 0}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a primeira página"
            style={startIndex === 0 ? disabledButtonStyle : buttonBaseStyle}
          >
            <i className="bi bi-chevron-double-left" style={iconStyle}></i>
          </button>
          <button
            className="btn btn-sm btn-light"
            onClick={onPreviousItems}
            disabled={startIndex === 0}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a página anterior"
            style={startIndex === 0 ? disabledButtonStyle : buttonBaseStyle}
          >
            <i className="bi bi-chevron-left" style={iconStyle}></i>
          </button>
          <span className="text-center" style={pageInfoStyle}>
            {startIndex + 1} - {Math.min(endIndex, totalItems)} de {totalItems}
          </span>
          <button
            className="btn btn-sm btn-light"
            onClick={onNextItems}
            disabled={endIndex >= totalItems}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a próxima página"
            style={endIndex >= totalItems ? disabledButtonStyle : buttonBaseStyle}
          >
            <i className="bi bi-chevron-right" style={iconStyle}></i>
          </button>
          <button
            className="btn btn-sm btn-light"
            onClick={onLastItems}
            disabled={endIndex >= totalItems}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Ir para a última página"
            style={endIndex >= totalItems ? disabledButtonStyle : buttonBaseStyle}
          >
            <i className="bi bi-chevron-double-right" style={iconStyle}></i>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Pagination10;
